var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"device-location-map",attrs:{"id":_vm.mapWrapperId}},[_c('div',{attrs:{"id":_vm.mapContainerId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }